module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "billingHistory",
    staticClass: "billing-history-modal",
    attrs: {
      "md-open-from": "#billingHistory",
      "md-close-to": "#billingHistory"
    },
    on: {
      "open": _vm.fixContent,
      "close": _vm.startOver
    }
  }, [_c('md-dialog-title', [_c('div', {
    staticClass: "modal-title"
  }, [_vm._v("Billing History")])]), _vm._v(" "), _c('md-dialog-content', {
    staticClass: "billing-history-modal-content"
  }, [_c('md-layout', {
    staticClass: "billing-history-table-content"
  }, [_c('table', {
    staticClass: "billing-history-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.invoices), function(invoice) {
    return _c('tr', {
      key: invoice.id
    }, [_c('td', [_vm._v(_vm._s(invoice.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice.amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice.description))]), _vm._v(" "), _c('td', {
      staticClass: "invoice-cell-status"
    }, [_vm._v(_vm._s(invoice.status))])])
  }), 0)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19ba8c76","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/billing-history.vue
// module id = 1209
// module chunks = 21